import { supabase } from '../supabase';

export const USERNAME_MAX_LENGTH = 30;
const USERNAME_PATTERN = /^[a-zA-Z0-9\s]+$/;

/**
 * Met à jour le pseudo d'un utilisateur après validation et vérification d'unicité.
 * Retourne le pseudo nettoyé (espaces de fin retirés) en cas de succès.
 */
export async function updateUsername(
  userId: number | string,
  newUsername: string
): Promise<{ success: boolean; username?: string; error?: string }> {
  const trimmed = newUsername.trim();

  if (!trimmed) {
    return { success: false, error: "Le nom d'utilisateur ne peut pas être vide" };
  }

  if (!USERNAME_PATTERN.test(trimmed)) {
    return {
      success: false,
      error: "Le nom d'utilisateur ne doit contenir que des lettres, des chiffres et des espaces",
    };
  }

  if (trimmed.length > USERNAME_MAX_LENGTH) {
    return {
      success: false,
      error: `Le nom d'utilisateur ne doit pas dépasser ${USERNAME_MAX_LENGTH} caractères`,
    };
  }

  try {
    // Des doublons historiques existent en base : limit(1) évite l'erreur "multiple rows".
    const { data: existingUsers, error: checkError } = await supabase
      .from('users')
      .select('user_id')
      .eq('username', trimmed)
      .limit(1);

    if (checkError) throw checkError;

    const existingUser = existingUsers?.[0];
    if (existingUser && Number(existingUser.user_id) !== Number(userId)) {
      return { success: false, error: "Ce nom d'utilisateur est déjà pris" };
    }

    const { error: updateError } = await supabase
      .from('users')
      .update({ username: trimmed })
      .eq('user_id', userId);

    if (updateError) throw updateError;

    return { success: true, username: trimmed };
  } catch (error) {
    console.error('Error updating username:', error);
    return { success: false, error: "Erreur lors de la mise à jour du nom d'utilisateur" };
  }
}
